import React from "react";
import {
  useHistory
} from "react-router-dom";

import ModelViewer from "../../../core/ModelViewer/ModelViewer";
import CameraViewer from '../../../core/CameraViewer/CameraViewer';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import styles from "./AugmentedViewer.module.css";

import {BASE} from '../../../Models';
import InstrcutionOverlay from "../../../core/InstructionOverlay/InstructionOverlay";

export default function AugmentedViewer(props: any) {

  const appSettings = JSON.parse(sessionStorage.getItem('avatar-app-settings')!) || {};
  const { avatarInstruction } = appSettings;
  const [showInstruction, setShowInstruction] = React.useState(!avatarInstruction);
  React.useEffect(() => {
    if(showInstruction){
      document.querySelector('body')?.classList.add('instruction');
    }else{
      document.querySelector('body')?.classList.remove('instruction');
    }
  },[showInstruction])

  const {id} = props;

  const history = useHistory();

  const viewer: any = React.useRef();

  
  const [currentModel, setCurrentModel] = React.useState("");
  React.useEffect(() => {
    const models = [ // Full Path needed
      `${BASE}/avatar/Joker_gruss.glb`,
      `${BASE}/avatar/Joker_FotoPose1.glb`,
      `${BASE}/avatar/Joker_FotoPose2.glb`,
      `${BASE}/avatar/Joker_Hut.glb`,
    ];
    const useInit = id ? parseInt(id) : 0;
    setCurrentModel(models[useInit]);
  }, [id]);

  if(currentModel){
    return (
        <div className={styles.Content}>
          <div className={styles.CameraContainer}>
            <CameraViewer />
          </div>
          <div className={'instruction-info-field'} style={{width: '100%', height: '100%'}}>
            <div className={'instruction-info-back center'} style={{
              backgroundColor: 'transparent',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              marginTop: '-15px',
              }}>
              <p className={'center'} style={{margin: 0}}>
                <br />
                <br />
                <br />
                <span className={'flex'}><img alt="" className={'instruction-icon'} src="/assets/images/instruction/touch_app_white_24dp.svg" /> drehen </span>
                <span className={'flex'}><img alt="" className={'instruction-icon'} src="/assets/images/instruction/zoom_white_24dp.svg" /> skalieren </span>
                <span className={'flex'}><img alt="" className={'instruction-icon'} src="/assets/images/instruction/double_finger_swipe_straight_white_24dp.svg" /> verschieben </span>
                <br />
                <br />
                <br />
                <br />
                <br />
                <span style={{textAlign: 'center'}} className={'flex'}>Für einen Schnapschussn nutze die Screenshotfunktion deines Endgeräts</span>
                <br />
                <br />
                <br />
                <br />
              </p>
              {/* <p className={'center'} style={{margin: 0, textAlign: "center"}}>
                
              </p> */}
            </div>
            <ModelViewer ref={viewer} src={currentModel} autoplay={true} hideShadow={true}/>
          </div>
          <div className={styles.Back}>
            <div className={'instruction-info-field'}>
              <div className={'instruction-info-back'} style={{
                }}>
                <p style={{right: 0, top:25, textAlign:'right'}}>
                  <span style={{whiteSpace: 'nowrap'}}>Zurück zur<br/></span>Auswahl
                </p>
              </div>
              <IconButton color="inherit" onClick={() => history.push(`/avatar`)}>
                  <CloseIcon fontSize="small" />
              </IconButton>
            </div>
          </div>
          <div onClick={() => {
            setShowInstruction(false);
            sessionStorage.setItem('avatar-app-settings', JSON.stringify({
              ...appSettings,
              avatarInstruction: true
            }))
          }}>
            {showInstruction ? <InstrcutionOverlay  /> : null}
          </div>
        </div>
    );
  }
  return <p>Loading</p>
}